import pMap from "@/utils/pMap";
import uniq from "lodash/uniq";
import imageService from "@/services/external/image.service";
import config from "@/config/config";
import { doIt } from "@/utils/doIt";

//

class ImageClientApi {
  public async uploadImage(imageUrl: string) {
    const startsWith = `http://res.cloudinary.com/${config.cloudinary.cloudName}`;
    const isUploaded = imageUrl.startsWith(startsWith);
    const url = await doIt(async () => {
      if (isUploaded) return imageUrl;
      return await imageService.uploadUnsigned(imageUrl);
    });
    return url;
  }

  //

  public async uploadMany(images: string[]) {
    const uniqImages = uniq(images);
    const uploaded = await pMap(uniqImages, this.uploadImage);
    return uploaded;
  }

  //

  public async uploadManyMapped(images: string[]) {
    const map = new Map(images.map((i) => [i, i]));

    await pMap(Array.from(map), async ([key, value]) => {
      const uploaded = await this.uploadImage(value);
      map.set(key, uploaded);
    });

    return map;
  }

  //

  public replaceByMap(images: string[], uploadedMap: Map<string, string>) {
    return images.map((i) => {
      const uploaded = uploadedMap.get(i);
      if (!uploaded) throw new Error("Uploaded is undefined");
      return uploaded;
    });
  }
}

//

export default new ImageClientApi();
